import React from 'react'

function DashboardPage() {
  return (
    <div>DashboardPage</div>
  )
}

export default DashboardPage